export const getFirstBackgroundTransitionState = (progress) => {
  const isDigitalRevealVisible = progress > 0.6;

  return {
    isDigitalRevealVisible,
    isFirstFixedBackgroundVisible: !isDigitalRevealVisible,
    shouldPauseFirstGradient: progress > 0.8,
  };
};
